function generateSrcset(src) {
  // Define the desired widths for the srcset
  const widths = [165, 360, 535, 750, 1070, 1500];

  // Generate the srcset attribute with different widths
  const srcset = widths
    .map(function (width) {
      return `${src}?width=${width} ${width}w`;
    })
    .join(',');

  return srcset;
}

function updateVariantOptionsAvailability(variants, inputs, value) {
  // Reset values
  Array.from(inputs).forEach(function (input) {
    input.parentElement.style.opacity = 1;
    input.disabled = false;
    input.parentElement.classList.remove('disabled');
  });

  const unavailableVariants = variants.filter(
    (v) => v.title.includes(value) && !v.available
  );

  unavailableVariants.forEach(function (v) {
    const inputToDisabled = Array.from(inputs).find((i) => {
      return (
        v.option1 === i.value || v.option2 === i.value || v.option3 === i.value
      );
    });

    inputToDisabled.parentElement.classList.add('disabled');
    inputToDisabled.parentElement.style.opacity = 0.5;
    inputToDisabled.disabled = true;
  });
}

function submitQuickAdd(variant, elements, buttonParentElement) {
  buttonParentElement.classList.add('is-loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: variant.id,
          quantity: 1,
        },
      ],
      sections: 'cart-icon-bubble,cart-drawer',
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        buttonParentElement.classList.remove('is-loading');
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function (data) {
      const overlay = document.querySelector('.drawer');

      if (!overlay.classList.contains('is-open')) {
        elements.cartNotification.renderContents(data);
      }


      console.log(buttonParentElement);

      const quickAddForm = buttonParentElement.closest('[data-js-element="quick-add-form"]');


      const inputs = {
        size: quickAddForm.querySelectorAll('input[name="Size"]'),
      };

      // After submission logic is completed, reset the input's checked state
      inputs.size.forEach(function (radioInput) {
        radioInput.checked = false; // Reset to unchecked
      });

      buttonParentElement.classList.remove('is-loading');
    })
    .catch(function (error) {
      console.error(
        'There has been a problem with your fetch operation: ',
        error
      );
      buttonParentElement.classList.remove('is-loading');
    });
}

function initQuickAdd() {
  disableUnavailableVariant();
  const elements = {
    cartNotification:
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer'),
    quickAddButtons: document.querySelectorAll('.quick-add'),
  };

  if (!elements.quickAddButtons) {
    return;
  }

  elements.quickAddButtons.forEach(function (button) {
    const buttonParentElement = button.closest('.quick-add_container');
    const quickAddForm = button.closest('[data-js-element="quick-add-form"]');
    const firstProductImage = quickAddForm.querySelector(
      '.pdp-first__image img'
    );

    const inputs = {
      size: quickAddForm.querySelectorAll('input[name="Size"]'),
      color: quickAddForm.querySelectorAll('input[name="Color"]'),
      all: quickAddForm.querySelectorAll('input[type="radio"]'),
    };

    if (quickAddForm.classList.contains('is-unavailable')) {
      return;
    }

    const productVariants = JSON.parse(quickAddForm.dataset.productVariants);

    // Button clicks

    quickAddForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();

      // find all checked radio input
      const checkedRadioInputs = quickAddForm.querySelectorAll(
        'input[type="radio"]:checked'
      );

      // get all checked radio input values
      const optionValues = Array.from(checkedRadioInputs).map(function (
        checkedRadioInput
      ) {
        return checkedRadioInput.value;
      });

      // find the variant that matches the selected options
      const variant = productVariants.find(function (variant) {
        return (
          (variant.title === optionValues.join(' / ') && variant.available) ||
          (variant.option1 === 'Default Title' && variant.available)
        );
      });

      // @TODO: Add conditional for if the product is sold out
      // @TODO: Add conditional if the variant is "default title" not to show it.

      // add to cart
      submitQuickAdd(variant, elements, buttonParentElement);
    });

    // ALL INPUTS

    inputs.all.forEach(function (radioInput) {
      radioInput.addEventListener('change', function (event) {
        // find all checked radio input
        const checkedRadioInputs = quickAddForm.querySelectorAll(
          'input[type="radio"]:checked'
        );

        // get all checked radio input values
        const optionValues = Array.from(checkedRadioInputs).map(function (
          checkedRadioInput
        ) {
          return checkedRadioInput.value;
        });

        // find the variant that matches the selected options
        const variant = productVariants.find(function (variant) {
          return variant.title === optionValues.join(' / ');
        });

        if (variant && variant.featured_image) {
          const src = variant.featured_image.src;
          const srcset = generateSrcset(src);
          if (srcset) {
            firstProductImage.srcset = srcset;
          }
        }
      });
    });

    // COLOR INPUTS

    inputs.color.forEach(function (radioInput) {
      if (radioInput.checked) {
        updateVariantOptionsAvailability(
          productVariants,
          inputs.all,
          radioInput.value
        );
      }

      radioInput.addEventListener('change', function (event) {
        const value = event.target.value;

        updateVariantOptionsAvailability(productVariants, inputs.all, value);
      });
    });

    // SIZE INPUTS
    inputs.size.forEach(function (radioInput) {
      radioInput.addEventListener('change', function (event) {
        // find all checked radio input
        const checkedRadioInputs = quickAddForm.querySelectorAll(
          'input[type="radio"]:checked'
        );

        // get all checked radio input values
        const optionValues = Array.from(checkedRadioInputs).map(function (
          checkedRadioInput
        ) {
          return checkedRadioInput.value;
        });

        // find the variant that matches the selected options
        const variant = productVariants.find(function (variant) {
          return variant.title === optionValues.join(' / ');
        });

        // add to cart
        submitQuickAdd(variant, elements, buttonParentElement);
      });
    });
  });
}

function disableUnavailableVariant() {
  const radioInputs = Array.from(
    document.querySelectorAll('input[name="Size"]')
  );

  radioInputs.forEach((radioInput) => {
    const variantData = JSON.parse(
      radioInput
        .closest('.js-variant-radios')
        .querySelector('[type="application/json"]').textContent
    );

    const unavailableVariants = [];

    variantData.filter((v) => {
      if (v.option1 === radioInput.value) {
        if (!v.available) {
          unavailableVariants.push(radioInput);
        }
      }
    });

    unavailableVariants.forEach((input) => {
      input.classList.add('unavailable');
      input.disabled = true;
      const inputLabel = input
        .closest('.js-parent-radio-container')
        .querySelector('.js-radio-size-label');
      const inputCrossLineSvg = input
        .closest('.js-parent-radio-container')
        .querySelector('.js-product-from__select-svg-unavailable');

      if (inputLabel) {
        inputLabel.classList.add('unavailable');
      }
      if (inputCrossLineSvg) {
        inputCrossLineSvg.classList.add('unavailable');
      }
    });
  });
}

window.addEventListener('load', initQuickAdd);

document.addEventListener('filters-activated', (e) => {
  initQuickAdd();
});
